export default "__VITE_ASSET__ZuMJWgt5__"